if (document.getElementById('cookiebar')) {
    var bar = document.getElementById('cookiebar');
    let root = document.documentElement;
    offsetHeight = bar.offsetHeight;
    root.style.setProperty('--cookiebar-height', offsetHeight + "px");
}